export const containsAction = (arr, action) => {
  return !!arr.find((it) => {
    return it.actionId === action.id;
  });
};

export const removeAction = (arr, action) => {
  return arr.filter((it) => it.actionId !== action.id);
};
